import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useState } from "react";
import { Container } from "reactstrap";
import PersonsForm from "./PersonsForm";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addPerson as onAddPerson } from "../../slices/thunks";
import { useNavigate, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { LEVEL_COUNTRY } from "common/constants";

const AddPerson = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Add Person");

  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      title: "",
      firstName: "",
      surname: "",
      middleName: "",
      gender: "",
      dateOfBirth: "",
      currentNationality: {
        value: "",
        label: "",
      },
      nationalityAtBirth: {
        value: "",
        label: "",
      },
      alias: [""],
      phoneNumber: [""],
      emailAddress: [""],
      physicalAddress: [
        {
          city: "",
          country: "",
          address: "",
        },
      ],
      postalAddress: [
        {
          city: "",
          country: "",
          address: "",
        },
      ],
      websiteOrLink: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please select title"),
      firstName: Yup.string().required("Please enter first name"),
      surname: Yup.string().required("Please enter surname"),
      middleName: Yup.string(),
      alias: Yup.array().of(Yup.string()),
      currentNationality: Yup.object().shape({
        value: Yup.number(),
      }),
      nationalityAtBirth: Yup.object().shape({
        value: Yup.number(),
      }),
      gender: Yup.string(),
      dateOfBirth: Yup.string(),
      photo: Yup.array(),
      phoneNumber: Yup.array().of(Yup.string()),
      emailAddress: Yup.array().of(Yup.string()),
      physicalAddress: Yup.array().of(
        Yup.object({
          city: Yup.string(),
          country: Yup.string(),
          address: Yup.string(),
        })
      ),
      postalAddress: Yup.array().of(
        Yup.object({
          city: Yup.string(),
          country: Yup.string(),
          address: Yup.string(),
        })
      ),
      websiteOrLink: Yup.string(),
    }),
    onSubmit: (values: any) => {
      const data = {
        data: {
          title: values["title"] || null,
          firstName: values["firstName"] || null,
          surname: values["surname"] || null,
          middleName: values["middleName"] || null,
          currentNationality: values["currentNationality"]["value"] || null,
          nationalityAtBirth: values["nationalityAtBirth"]["value"] || null,
          alias:
            Array.isArray(values["alias"]) && values["alias"].length > 0
              ? values["alias"].map((el) => {
                  return {
                    name: el,
                  };
                })
              : null,
          gender: values["gender"] || null,
          dateOfBirth: values["dateOfBirth"] || null,
          phoneNumber:
            Array.isArray(values["phoneNumber"]) &&
            values["phoneNumber"].length > 0
              ? values["phoneNumber"]
                  .map((el) => {
                    if (el !== "") {
                      return {
                        name: el,
                      };
                    }
                    return null;
                  })
                  .filter((el) => el !== null)
              : null,
          emailAddress:
            Array.isArray(values["emailAddress"]) &&
            values["emailAddress"].length > 0
              ? values["emailAddress"]
                  .map((el) => {
                    if (el !== "") {
                      return {
                        name: el,
                      };
                    }
                    return null;
                  })
                  .filter((el) => el !== null)
              : null,
          physicalAddress: values["physicalAddress"] || null,
          postalAddress: values["postalAddress"] || null,
          websiteOrLink: values["websiteOrLink"] || null,
        },
      };

      setLoading(true);
      dispatch(
        onAddPerson({
          level: LEVEL_COUNTRY,
          params: data,
        })
      ).then((result: any) => {
        setLoading(false);
        if (result?.payload?.data) {
          navigate("/persons/" + result?.payload?.data?.id);
        }
      });
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Add Person"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "Persons", link: "/persons" },
          ]}
          back
        />

        <PersonsForm
          validation={validation}
          isUpdate={false}
          loading={loading}
          setLoading={setLoading}
        />
      </Container>
    </div>
  );
};

export default AddPerson;
